module.exports = __webpack_public_path__ + "img/b9.09e776b8.png";